import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Svgs } from "../../assets";
import Navbar from "../../components/common/Navbar";
import { Link } from "react-scroll";
import "./index.scss";
import { CustomModal } from "../../components/common/CustomModal";
import { data } from "./data";

const Home = () => {
  const bgRef = useRef();
  const [modalShow, setModalShow] = useState(false);
  const [content, setContent] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSend = () => {
    window.open(
      "mailto: peter.odekwo@gmai.com?&subject=" + subject + "&body=" + message,
      "_self"
    );
  };
  const handleSelect = (project) => {
    setContent(project);
    setModalShow(true);
  };
  useEffect(() => {
    const windowWidth = window.innerWidth / 5;
    const windowHeight = window.innerHeight / 5;

    bgRef.current.addEventListener("mousemove", (e) => {
      const mouseX = e.pageX / windowWidth;
      const mouseY = e.pageY / windowHeight;
      bgRef.current.style.backgroundPosition = `${-mouseX * 12}px  ${
        -mouseY * 12
      }px`;
    });
  }, []);
  const handleTwitter = () => {
    window.open("https://drive.google.com/file/d/11BLseDBbg-5owex6voDs83L9cIvZWhyD/view?usp=drive_link");
  };

  const handleLinkedIn = () => {
    window.open("https://www.linkedin.com/in/peter-odekwo/");
  };
  const handleGithub = () => {
    window.open("https://github.com/pitaz");
  };
  return (
    <>
      <div className="home">
        {/* jumbo header */}
        <section className="jumbo-header" id="jumbo-header" ref={bgRef}>
          <div className="nav-wrapper">
            <Navbar />
          </div>
          <div className="wrap">
            <div className="container">
              <div className="jumbo-header__text-section">
                <div className="block">
                  <div className="greeting-emoji">
                    <p className="greetings-text">{`<Hello! />`}</p>
                    <img
                      className="emoji"
                      src="https://firebasestorage.googleapis.com/v0/b/portfolio-17056.appspot.com/o/emoji.png?alt=media&token=b6bd18ec-a1ae-4921-86f3-9c7be221f1b0"
                      alt="emoji"
                    />
                  </div>
                  <p className="greetings-text">Frontend Engineer</p>
                  <p className="sub-text">
                    Hi, my name is Peter, an adept frontend engineer enriched
                    with comprehensive full stack proficiency. My expertise
                    encompasses crafting remarkable digital experiences across
                    both web and mobile platforms, consistently striving for
                    excellence.
                  </p>
                  {/* <p className="sub-text">
                  What started as a way to manage multiple servers on one system
                  has grown into the way we develop, write code, ship
                  applications, and coordinate large scale applications!
                  Containers may have started as tools for the ops team, but now
                  everyone needs to learn to build and use them. In this course
                  you’ll learn, what containers are and how to create containers
                  from scratch, how to run containers from Dockerhub..
                </p> */}
                </div>
              </div>
            </div>
            <div className="icons">
              {/* <div className="social-icons"> */}
              {/* <Svgs.FACEBOOK fill="#fff" width={25} height={25} /> */}
              <Svgs.CLOUD_DOWNLOAD
                fill="#fff"
                width={25}
                height={25}
                className="social-icon"
                onClick={handleTwitter}
              />
              <Svgs.LINKEDIN
                fill="#fff"
                width={25}
                height={25}
                className="social-icon"
                onClick={handleLinkedIn}
              />
              <Svgs.GITHUB
                fill="#fff"
                width={25}
                height={25}
                className="social-icon"
                onClick={handleGithub}
              />
              {/* <Svgs.INSTAGRAM
              fill="#fff"
              width={25}
              height={25}
              className="social-icon"
            /> */}
              {/* </div> */}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Link
              to="experience"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <div className="scroll-down">
                <FontAwesomeIcon icon={faChevronDown} />
              </div>
            </Link>
          </div>
        </section>
        {/* jumbo header */}
        <section className="about-me"></section>
        <section className="work-experience">
          <p className="title" id="experience">
            Stack
          </p>

          <div className="skills">
            <div className="stack">
              <p>Javascript</p>
              <p>Typescript</p>
              <p>React</p>
              <p>React Native</p>
              <p>CSS</p>
              <p>HTML</p>
              <p>Next JS</p>
              <p>Nest JS</p>
              <p>GraphQL</p>
              <p>Node JS</p>
              <p>Cypress</p>
              <p>Express</p>
              <p>Redux</p>
              <p>MobX</p>
              <p>AWS</p>
              <p>Firebase</p>
              <p>PHP</p>
              <p>Java</p>
            </div>
          </div>
        </section>
        <section className="work-experience">
          <p className="title" id="project">
            Projects
          </p>
          <div className="project-grid-wrapper">
            <div className="project-grid">
              {data.map((project, index) => (
                <div
                  className="grid-content"
                  key={index}
                  onClick={() => handleSelect(project)}
                >
                  <img
                    src={project.image}
                    alt="project"
                    className="project-image"
                  />
                  <div className="footer">
                    <p>{project.name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <p className="title">Contact</p>
          <div className="contact">
            <input
              className="input"
              placeholder="Email subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
            <textarea
              className="textarea"
              placeholder="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <div className="button-wrapper">
              <button onClick={handleSend}>Send</button>
            </div>
          </div>

          <div>
            <p className="footer-text">
              Designed with&nbsp;
              <span role="img" aria-label="Panda">
              &nbsp;
                ❤️&nbsp;
              </span>&nbsp;
              by Peter Odekwo
            </p>
            <p className="footer-text">{new Date().getFullYear()}</p>
          </div>
        </section>
      </div>
      <CustomModal
        content={content}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Home;
